/**
 * Point d'entrée JavaScript custom Atelier 109.
 *
 * Convention : chaque composant sur-mesure est un custom element `<a109-…>`
 * qui étend la classe de base d'Horizon `Component` (@theme/component).
 * On réutilise ainsi le système de `ref`, les événements déclaratifs
 * (`on:click="/method"`) et l'hydratation d'Horizon — pas de framework parallèle.
 *
 * Ce fichier est chargé en `type="module"` après l'importmap Horizon,
 * donc les alias `@theme/*` sont résolus.
 *
 * Voir docs/adr/0003-js-custom-sur-runtime-horizon.md
 */

import { Component } from '@theme/component';

/**
 * Composant d'exemple — à dupliquer / remplacer.
 *
 * Usage Liquid (dans une section ou un snippet a109-*) :
 *   <a109-example>
 *     <button ref="trigger" on:click="/handleClick">Cliquer</button>
 *   </a109-example>
 *
 * @extends Component
 */
class A109Example extends Component {
  connectedCallback() {
    super.connectedCallback();
    // Initialisation ici. Les refs sont accessibles via this.refs.<nom>.
  }

  /** Appelé par l'attribut déclaratif `on:click="/handleClick"`. */
  handleClick() {
    // Logique du composant…
  }
}

if (!customElements.get('a109-example')) {
  customElements.define('a109-example', A109Example);
}
